import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-table-field-label',
  templateUrl: './table-field-label.component.html',
  styleUrls: ['./table-field-label.component.scss']
})
export class TableFieldLabelComponent implements OnInit {

  @Input() fieldName: string;
  @Input() fieldLabel: string;

  constructor() {
    this.fieldName = 'Fecha';
  }

  ngOnInit() {
  }

}
